<header class="flex flex-row justify-between items-center w-full h-60px sm:h-80px">
    <nav class="lg:gap-x-30px">
        <!-- logo column -->
        <div
            class="lg:w-full max-w-menu lg:max-w-menu-lg flex flex-row items-center pl-20px lg:pr-20px justify-start lg:justify-end"
        >
            <div class="flex-shrink-0 logo" (click)="onLogoClick()">
                <mat-icon svgIcon="evida_my_evida_logo" inline="true"></mat-icon>
            </div>
        </div>

        <!-- middle "content" column -->
        <!-- <div [style.width.px]="contentWidth$ | async"></div> -->
        <div class="h-full flex items-center sm:pr-10px">
            <!-- the other column-->
            @if (authService.isAuthenticated) {
                <div
                    class="flex justify-start items-center gap-x-10px flex-grow cursor-pointer"
                    (click)="toggleProfileDropdown()"
                >
                    <div class="flex flex-auto justify-start items-center gap-x-10px flex-grow">
                        <!-- Profile Icon -->
                        @if (!hideProfileSection) {
                            <div>
                                <img
                                    src="../../../../assets/image/mit_evida_profile.svg"
                                    class="h-full w-auto align-middle"
                                    alt="profile icon"
                                />
                            </div>
                        }
                        @if (!hideProfileSection) {
                            <div class="flex flex-col associatedUserName">
                                <span class="body-small-header" title="">{{ associatedUserName | emptyField }}</span>
                            </div>
                        }
                    </div>
                    <ng-content></ng-content>
                </div>
            }
        </div>
    </nav>
    <div class="absolute left-0 top-60px sm:top-80px h-px bg-petroleum10pct w-full"></div>
</header>
@if (unavailable()) {
    <div class="flex flex-row justify-center w-full orange">
        Det er ikke muligt at bestille afkobling af gasforsyning fra den 29. august kl. 14 til den 1. september kl. 9 på
        grund af systemopdatering
    </div>
}
